import PropTypes from 'prop-types';
import React from 'react';

import Icon from '../../Icon';

const IconButton = ({
  iconName,
  iconSize,
  className,
  iconColor,
  disabled,
  ...buttonProps
}) => {
  let btnClassName = 'icon-button';

  if (className) {
    btnClassName = `${btnClassName} ${className}`;
  }

  return (
    <div {...{ ...buttonProps, disabled, className: btnClassName }}>
      <Icon
        name={iconName}
        size={iconSize}
        color={iconColor}
        disabled={disabled}
      />
    </div>
  );
};

IconButton.propTypes = {
  iconName: PropTypes.string,
  iconSize: PropTypes.string,
  className: PropTypes.string,
  iconColor: PropTypes.string,
  disabled: PropTypes.bool,
};

export default IconButton;
